import StyledLink from '../StyledLink'
import {
  SYSTEM,
  WEBHOOK
} from '../routes'
import type { Props } from '../types'

const LinkToWebhook = ({
  children,
  isHyperlink,
  isRenderIcon,
  isInlineLink,
  openInNewTab
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    isInlineLink={isInlineLink}
    isRenderIcon={isRenderIcon}
    openInNewTab={openInNewTab}
    to={'/' + SYSTEM + '/' + WEBHOOK}
  >
    {children}
  </StyledLink>

export default LinkToWebhook
